"use client";
import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const HeroAboutSection = () => {
  const handleReload = () => {
    window.location.reload();
  }
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <motion.section
      ref={ref}
      className="overflow-hidden relative flex justify-center items-center w-full bg-orange-50 min-h-[600px] px-4 md:px-8"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      role="banner"
    >
      {/* Background Decorative Element */}
      {/* <div className="absolute inset-0 flex justify-center items-center">
        <div
          dangerouslySetInnerHTML={{
            __html:
              "<svg width=\"554\" height=\"496\" viewBox=\"0 0 554 496\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"hero-ellipse\" style=\"width: 300px; height: 500px; transform: rotate(30deg); border-radius: 650.718px; background: #FFE0D1; position: absolute; opacity: 0.3;\"> <ellipse cx=\"277.17\" cy=\"247.948\" rx=\"178.709\" ry=\"325.359\" transform=\"rotate(30 277.17 247.948)\" fill=\"#FFE0D1\"></ellipse> </svg>",
          }}
        />
      </div> */}

      <div className="relative z-10 w-full max-w-6xl mx-auto flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-16 min-h-[500px]">

        {/* Left Content */}
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left max-w-2xl">
          <motion.h1
            className="text-5xl md:text-6xl lg:text-7xl text-cyan-900 mb-6"
            style={{ fontFamily: "'Sansita Swashed', cursive" }}
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Welcome to
          </motion.h1>

          <motion.h2
            className="text-4xl md:text-5xl lg:text-6xl text-red-500 mb-8"
            style={{ fontFamily: "'Sansita Swashed', cursive" }}
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Iyna Cakes & Desserts!
          </motion.h2>

          <motion.p
            className="text-lg md:text-xl text-[#698F8C] mb-8 leading-relaxed"
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            At Iyna Cakes, we believe that every celebration deserves a delicious memory.
            We specialize in custom cakes, cupcakes, desserts, and sweet treats that bring
            smiles to every occasion.
          </motion.p>

          <motion.p
            className="text-lg md:text-xl text-[#698F8C] mb-8 leading-relaxed"
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            What started as a small passion for baking has now grown into a trusted name
            for quality, creativity, and heartwarming flavors. Whether it's a birthday,
            wedding, baby shower, or just a craving for something sweet – we're here to
            make it extra special.
          </motion.p>

          <motion.button
            className="flex gap-2 justify-center items-center px-8 md:px-11 py-4 md:py-5 bg-red-500 rounded-[40.5px] text-lg md:text-xl font-bold text-white hover:bg-red-600 transition-colors"
            onClick={handleReload}
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.8, delay: 1.0 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Explore Our Story
          </motion.button>
        </div>

        {/* Right Content - Decorative Image */}
        <motion.div
          className="relative w-full max-w-md lg:max-w-lg"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={inView ? { scale: 1, opacity: 1 } : { scale: 0.8, opacity: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <div className="text-9xl text-center">🧁</div>
          <div className="absolute -top-4 -right-4 text-4xl">✨</div>
          <div className="absolute -bottom-4 -left-4 text-4xl">🎂</div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default HeroAboutSection;
